<template>
  <section class="agenda wednesday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, May 14th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                Lunch <br> @ 4th Floor
              </p>
              <div class="cards__description">
                <p>12:30 PM - 2:30 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 8:00 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                Legends Never Die Party
              </p>
              <div class="cards__description">
                <p>10:00 PM - 1:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
      {
          name: 'Fireside Chat - Beyond Traditional Finance: How DeFi is Redefining Financial Services',
          title: 'Moderator: Ken DiCross - CEO, Wire Network<br> Enzo Villani - Founder & CEO, Alpha Transform Holdings<br> Michael Terpin - Founder & CEO, Transform Group<br>Anthony Scaramucci - Founder & Managing Partner, SkyBridge Capital',
          time: '1:00 PM - 1:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'Cross-Chain Interoperability: Building the financial rails of the new digital economy and how Wire Network is leading the way',
          title: 'Moderator: Ken DiCross - CEO, Wire Network<br>Douglas Keeney - CBDO, Wire Network',
          time: '1:30 PM - 2:00 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'bittensor',
          name: 'Bittensor Explained: Rewriting the Future of Intelligence and Economy',
          title: 'Mike Grantis',
          time: '2:00 PM - 2:30 PM',
          class: 'logo'
        },
        {
          name: "Regulatory Clarity and Compliance: Navigating DeFi's Path to Legitimacy",
          title: 'Carlos Duque - Chief Legal Officer, Wire Network<br> Toufic Adlouni - Co-Founder, Renno & Co<br>Nima Maleki - Counsel, Day One Law',
          time: '2:30 PM - 3:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Kraken Fireside with Chris Miglino - Everything On-Chain: The Race to Tokenize the Global Economy',
          title: 'Calvin Leyon - President, Kraken<br>Chris Miglino - CEO & Co-Founder, DNA',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'wow',
          name: 'WOW!?',
          title: 'Rick Latona, Founder & CEO',
          time: '3:30 PM - 3:40 PM',
          class: 'logo'
        },
        {
          name: 'Oregon Blockchain: Kids in Crypto',
          title: 'Moderator: Shanti Miglino, Research Analyst and Marketing<br>Cameron Coleman, President<br>Shantam Tyagi, Venture Capital Analyst<br>Jacob Cordova, Venture Capital Analyst<br>Drew Manley, Director of Consulting<br>Armaan Hajar, Technical Consultant',
          time: '3:40 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Fireside Chat - Plugging In: Layer One Integration That Actually Delivers',
          title: 'Bill Papp - CEO, Polymesh<br>Nick Cafaro - Head of Product, Polymesh',
          time: '4:00 PM - 4:30 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'bos',
          name: 'BitcoinOS',
          title: 'Edan Yago, CEO & Co-Founder',
          time: '4:30 PM - 4:40 PM',
          class: 'logo'
        },
        {
          name: 'Stablecoins and the Evolution of Digital Money',
          title: 'Ken DiCross - CEO, Wire Network<br>Jana Bertram - Head of Strategy, Rari Foundation',
          time: '4:40 PM - 5:10 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'kredete',
          name: 'Kredete',
          title: 'Adeola Adedewe, Founder & CEO',
          time: '5:10 PM - 5:20 PM',
          class: 'logo'
        },
        {
          logoClass: 'manifest',
          name: 'Manifest',
          title: 'Eric Bravick, Founder',
          time: '5:20 PM - 5:30 PM',
          class: 'logo'
        },
      ],
      afternoonSet: [
        {
          name: 'Why Tokenize? Unlocking the Future of Asset Ownership',
          title: 'Moderator: Natalie Hirsch - CFO, Polymath<br>Hunter Milborne - Founder & CEO, Milborne Group<br>Kirill Soloviev - CEO & Co-Founder, ContentQuo<br>Richard Dolan, Entrepreneur',
          time: '5:30 PM - 5:50 PM',
          class: 'noheight panel'
        },
        {
          name: 'By the Numbers: The Polymath Growth Playbook ',
          title: 'Moderator: Vince Kadar - CEO, Polymath<br>Natalie Hirsch - CFO, Polymath<br>Andrew Howarth - Partner, Walkers LLP',
          time: '5:50 PM - 6:00 PM',
          class: 'noheight panel'
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
